import { useEffect, useState } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

const PDP_SIDERAIL_CONTACT_SELLER = 'pdpSiderailContactSeller' as const;

export const usePdpSiderailContactSellerClientVariant = (): boolean | null => {
    const [isPdpSiderailContactSellerClientVariant, setPdpSiderailContactSellerClientVariant] =
        useState<boolean | null>(null);

    useEffect(() => {
        setPdpSiderailContactSellerClientVariant(
            getAbTestV2(PDP_SIDERAIL_CONTACT_SELLER)?.variant === 'variant'
        );
    }, []);

    return isPdpSiderailContactSellerClientVariant;
};

export const trackPdpSiderailContactSellerClientVariant = (): void => {
    trackAbTestV2Variant(PDP_SIDERAIL_CONTACT_SELLER);
};
